export class ClusterSearchParameters {
  private idCluster: string;
  private startIndex: number;
  private totalPerPages: number;
  private total: number;
  private filterText: string;

  public getStartIndex(): number {
    return this.startIndex;
  }

  public getTotalPerPages(): number {
    return this.totalPerPages;
  }

  public getTotal(): number {
    return this.total;
  }

  public getFilterText(): string {
    return this.filterText;
  }

  public getIdCluster(): string {
    return this.idCluster;
  }

  public setStartIndex(value: number) {
    this.startIndex = value;
  }

  public setTotalPerPages(value: number) {
    this.totalPerPages = value;
  }

  public setTotal(value: number) {
    this.total = value;
  }

  public setFilterText(value: string) {
    this.filterText = value;
  }

  public setIdCluster(value: string) {
    this.idCluster = value;
  }
}
